import { useTranslation } from '@nextgen-web-framework/all';
import { ProductLink } from '../../Hoc';
import {
  BasicDetailsComponent,
  DetailsType,
  IdAndSizeType,
  ImageComponent,
  ImageType,
  ProductIdAndSizeComponent,
  ProductQuantityComponent,
  ProductQuantityType,
} from '../../Molecules';
import styles from './APointRedeemProductCard.module.scss';
import type {
  APointAdditionalInfoType,
  APointPriceCompanionTextType,
  APointRedeemProductCardPropsTypes,
} from './types/propsTypes';

/** @deprecated This component is deprecated from UI. Use the same component from ui-composite. */
const APointRedeemProductCard = (props: APointRedeemProductCardPropsTypes): JSX.Element => {
  const {
    productQuantity,
    showAPointAdditionalInfo = {
      showQuantity: false,
      showProductId: false,
      showProductSize: false,
    },
    showLink,
    productData,
  } = props;

  const {
    mainLink: mainLinkPD,
    productId: productIdPD,
    alt: altPD,
    brandName: brandNamePD,
    productName: productNamePD,
    aPointPrice: aPointPricePD,
    productSize: productSizePD,
    aPointPriceCompanionText: aPointPriceCompanionTextPD,
  } = productData || {};

  const t = useTranslation();
  const aPointText = `${aPointPricePD} ${t('product.APointRedeemCard.aPointText')}`;
  const productLinkProps = {
    className: styles['width-inherit'],
    showLink: !!showLink,
    href: '',
    productId: productIdPD ?? '',
    productName: productNamePD ?? '',
  };

  function isFullSizeImage() {
    return !showAPointAdditionalInfo?.showProductId && !showAPointAdditionalInfo?.showProductSize;
  }

  const image = (type: string) => (
    <ProductLink {...productLinkProps}>
      <div className={`${styles['product-image-container']} ${styles['width-inherit']}`}>
        <ImageComponent link={mainLinkPD ?? ''} alt={altPD ?? ''} imagetype={type} />
      </div>
    </ProductLink>
  );

  const basicDetails = (type: string, mainText = brandNamePD ?? '', subText = productNamePD ?? '') => (
    <ProductLink {...productLinkProps}>
      <div className={styles['cpw-basic-details']}>
        <BasicDetailsComponent brandName={mainText} productName={subText} detailsType={type} />
      </div>
    </ProductLink>
  );

  return (
    <div className={styles[`cpw-apoint-product-card`]} data-testid="cpw-apoint-product-card-test-id">
      <div
        className={`${styles['apoint-redeem-product-card-view']} ${styles['cpw-apoint-card-container']}`}
        data-testid="apoint-product-card-container-testID"
      >
        <div
          className={`${styles['product-image']} ${
            isFullSizeImage() ? styles['apoint-product-image-height'] : styles['apoint-product-small-image']
          }`}
          data-testid="apoint-product-card-image-testID"
        >
          {image(ImageType.APOINT_REDEEM_CARD)}
        </div>
        <div className={styles['product-description']}>
          <div>
            {basicDetails(DetailsType.APOINT_REDEEM_PRODUCT_CARD)}
            <ProductIdAndSizeComponent
              productId={productIdPD ?? ''}
              idSizeType={IdAndSizeType.ID_SIZE_APOINT_CARD}
              showProductId={showAPointAdditionalInfo?.showProductId || false}
              productSize={showAPointAdditionalInfo?.showProductSize ? productSizePD ?? '' : ''}
            />
          </div>
          <div
            className={styles['product-points-quantity-info']}
            data-testid="product-points-quantity-container-test-id"
          >
            {basicDetails(DetailsType.APOINT_REDEEM_PRODUCT_CARD_PRICE_DETAILS, aPointText, aPointPriceCompanionTextPD)}

            {showAPointAdditionalInfo?.showQuantity && !isNaN(productQuantity as number) && (
              <ProductQuantityComponent
                productQuantity={productQuantity}
                productQuantityType={ProductQuantityType.APOINT_PRODUCT_CARD}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default APointRedeemProductCard;
export type { APointAdditionalInfoType, APointPriceCompanionTextType, APointRedeemProductCardPropsTypes };
